//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Helpers
import { getSystemStyle } from '../../chart_helper';
// Design system components
import { SystemStyles } from '@Shelly/shelly-design-system';

export default {
	afterDraw: (chart) => {
		if (chart.data.datasets.length === 0 && !chart.data.isLoading) {
			const ctx = chart.ctx,
				chartArea = chart.chartArea;
			ctx.save();
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.font = `12px ${getSystemStyle(SystemStyles.FONT_FAMILY)}`;
			ctx.fillStyle = getSystemStyle(SystemStyles.COLOR_WHITE);
			ctx.fillText(
				get(format)('no_data_available!', { default: 'No data available!' }),
				chart.width / 2,
				(chartArea.top + chartArea.bottom) / 2,
			);
			ctx.restore();
		}
	},
};
